import React from "react";
import { Table, Button } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { LuDownload } from "react-icons/lu";

const DataTable = ({ columns, data, reportName, excelData, fetchExcelData }) => {
  const [isExporting, setIsExporting] = React.useState(false);

  const exportToExcel = async () => {
    // Screens that hold every row keep passing excelData and behave exactly as
    // before. A screen that only holds one page of rows instead passes
    // fetchExcelData, which returns every row matching the current filters, so
    // the exported file is still the whole report rather than one page.
    let rowsToExport = excelData;
    if (typeof fetchExcelData === "function") {
      try {
        setIsExporting(true);
        rowsToExport = await fetchExcelData();
      } catch (error) {
        console.error("Error preparing export data:", error);
        setIsExporting(false);
        return;
      }
      setIsExporting(false);
    }
    if (!Array.isArray(rowsToExport)) rowsToExport = [];

    const ws = XLSX.utils.json_to_sheet(
      rowsToExport.map((rowData, rowIndex) =>
        columns.reduce((acc, column) => {
          acc[column.label] = column.render(rowData, rowIndex, true);
          return acc;
        }, {})
      )
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Get current date and time in ddmmyyyy_hhmm format
    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, "0")}${(
      now.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}${now.getFullYear()}`;
    const formattedTime = `${now.getHours().toString().padStart(2, "0")}${now
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
    const fileName = `${reportName}_${formattedDate}_${formattedTime}.xlsx`;

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };

  return (
    <>
      <section className="h-100 d-flex flex-column">
        <div className="d-flex justify-content-end align-items-center mb-1">
          <button
            onClick={exportToExcel}
            className="report-btn"
            disabled={isExporting}
          >
            <LuDownload />
            {isExporting ? "Preparing..." : "Download Excel"}
          </button>
        </div>

        <div className="master-table-wrapper table-responsive">
          <Table striped hover className="table-list">
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th key={index} style={{ minWidth: column.minWidth || "120px" }}>
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((rowData, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>{column.render(rowData, rowIndex)}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-4">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </section>
    </>
  );
};

export default DataTable;
